import React, { useState } from 'react'
import { PaymentMethod, useEventAttendee, EventAttendees } from '@modmd/data'
import { ApolloQueryResult } from '@apollo/client'
import { Dialog } from 'components/Dialog'
import { DEVICE, pxToRem } from 'theme'
import { useIsMinDevice } from 'utils/hooks/useMedia'
import { Tabber } from 'components/Tabber'
import { AboutAttendee } from './AboutAttendee'
import { EditResultEventSample } from './EditResultEventSample'
import { InsuranceAttendee } from './InsuranceAttendee'

interface AttendeeInfoProps {
  id: string
  companyId: string
  isOpen: boolean
  isClient?: boolean
  handleDismiss: () => void
  refetchAttendeesData: () => Promise<ApolloQueryResult<EventAttendees>>
}

export const AttendeeInfo: React.VFC<AttendeeInfoProps> = ({
  id,
  companyId,
  isOpen,
  isClient,
  handleDismiss,
  refetchAttendeesData,
}) => {
  const isMobile = !useIsMinDevice(DEVICE.TABLET)
  const [currentTab, setCurrentTab] = useState('About')

  const { data: attendeeData, loading: isLoadingData, refetch } = useEventAttendee({
    id,
    companyId,
  })

  return (
    <Dialog
      isOpen={isOpen}
      variant={isMobile ? 'fullscreen' : 'center'}
      maxWidth={pxToRem(800)}
      onDismiss={handleDismiss}
    >
      <Tabber
        activeTabName={currentTab}
        onChange={({ activeTabName }) => {
          setCurrentTab(activeTabName)
        }}
      >
        <Tabber.Item
          tabName="About"
          component={
            <AboutAttendee
              refetchAttendeesData={refetchAttendeesData}
              refetchModal={refetch}
              attendeeData={attendeeData}
              isLoadingData={isLoadingData}
            />
          }
        >
          About
        </Tabber.Item>
        {!isClient &&
        attendeeData?.eventAttendee?.Event?.paymentMethod === PaymentMethod.Insurance ? (
          <Tabber.Item
            tabName="Insurance"
            component={
              <InsuranceAttendee
                alreadyTested={!!attendeeData?.eventAttendee?.EventSamples?.length}
                insuranceData={attendeeData?.eventAttendee?.Payment?.[0]}
                attendeeId={attendeeData?.eventAttendee.id}
                refetch={refetch}
              />
            }
          >
            Insurance
          </Tabber.Item>
        ) : undefined}

        {attendeeData?.eventAttendee?.EventSamples?.length ? (
          <Tabber.Item
            tabName="Edit"
            component={
              <EditResultEventSample
                handleDismiss={() => {
                  handleDismiss()
                  setCurrentTab('About')
                }}
                refetchAttendeesData={refetchAttendeesData}
                eventSampleId={attendeeData?.eventAttendee?.EventSamples[0]?.id}
                result={attendeeData?.eventAttendee?.EventSamples[0]?.result}
                secondResult={attendeeData?.eventAttendee?.EventSamples[0]?.secondResult}
                testType={attendeeData.eventAttendee.Event.testType}
              />
            }
          >
            Edit
          </Tabber.Item>
        ) : undefined}
      </Tabber>
    </Dialog>
  )
}
